import { AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode } from "generated/CoreApi_v1";
import React from "react";
import { AssPlayerStartBox } from "./AssPlayerStartBox";
import { AssPlayerSummary } from "views/assessment/player/Start/AssPlayerSummary";

interface IProps {
    viewData: AssessmentInstanceDto;
    fullScreenMode: boolean;
}

export const AssPlayerStart: React.FC<IProps> = (props) => {

    const { viewData, fullScreenMode } = props;

    return (
        <>
            {
                viewData.mode == AssessmentMode.Survey && viewData.playerMode == AssessmentPlayerMode.FinalResult
                    ? <AssPlayerSummary viewData={viewData} fullScreenMode={fullScreenMode} />
                    : <AssPlayerStartBox viewData={viewData} fullScreenMode={fullScreenMode} />
            }
        </>
    );
};
